/**
 * 2022-08-24: Strange error? Check the dynamic update code below / mh
 */

import React, { useRef, useState, useEffect } from "react";
import Radio from './Radio'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import ValidationBar from '../common3/ValidationBar'

import filterString from '../common3/filterString'
import HelpIcon from '../common3/HelpBox/Icon'
import HelpBox from "../common3/HelpBox";

import { LabelWrapper, GroupLabel } from './styled'

const Radio3 = (props) => {
  const { extra = {}, value = null, save = () => { }, name = 'radio', id, effects, runEffect, formData, validationError = {}, disableValidation, dispatchEvent, htmlTemplates = {} } = props;
  let { label = 'test', subLabel = '', options = [
    { label: 'test', value: 'test' },
    { label: 'test2', value: 'test2' },
  ], optionsType = 'static', effects: extraEffects = null, helpBoxAlwaysVisible = false, helpBoxIcon = false, helpBoxTemplateId = null, helpBoxTemplate = null } = extra;

  const disabled = props.disabled || extra.disabled

  const [checkedValue, setCheckedValue] = useState(value)
  const [helpBoxOpen, setHelpBoxOpen] = useState(helpBoxAlwaysVisible ? true : false)

  let selectToDisplay = null

  let error = validationError.critical ? 'critical' : null
  let errorMessage = validationError.critical
  if (!error) {
    error = validationError.error ? 'danger' : null
    errorMessage = validationError.error
  }
  if (!error) {
    error = validationError.warning ? 'warning' : null
    errorMessage = validationError.warning
  }

  /**
   * MOUNT: Check for default values
   * 
   * Handle static-values first, then check for defaults
   */
  useEffect(() => {

    if (value === null && (optionsType === 'static' || optionsType === 'advanced')) {
      let newValue = null
      options.forEach(o => {
        if (o.setDefault) {
          newValue = o.value ? o.value : o.label
        }
      })
      setCheckedValue(newValue)
    }

  

  }, [])

  const mountRef = useRef()

  // Update-effect ensure that we component updates when value change
  // 2022-08-24: This was added because radio did not update dynamiclly. After the implementation
  // we noticed the uncommented code below. WE ARE NOT SURE WHY WE UNCOMMENTED THE CODE BELOW.
  // If there is any strange behaviour with this component is is most likely this.
  useEffect(() => {
    if( mountRef.current ) {
      if (value === null && extra.defaultStatic === true) {
        const defaultValue = filterString(extra.staticValue, props, {})

        setCheckedValue(defaultValue)
      } else {
        setCheckedValue(value)
      }
    } else {
      mountRef.current = true
    }
  }, [value])

  // /**
  //  * Effect to handle incoming new values, i.e. changes from outside the component
  //  * 
  //  * Notice that we do not call debouceSetValue, but we cancel all values
  //  */
  //  useEffect(() => {
  //   if (value === undefined || value === null) {
  //     const defaultValue = setDefaultValue({ extra, user, props,context : {} })

  //     if (defaultValue) {

  //       setInputValue(defaultValue)
  //       save({ key: id, value:defaultValue });
  //       //debouncedSetValue.cancel()
  //     }
  //   } else
  //     if (inputValue !== value) {
  //       setInputValue(value)
  //       debouncedSetValue.cancel()

  //     }
  // }, [value])


  useEffect(() => {
    if ((optionsType === 'effects' || optionsType === 'register') && !isEmpty(extraEffects)) {
      runEffect({ source: extraEffects, effectId: id })
    }
  }, [id, formData, optionsType, runEffect, extraEffects])

  if ((optionsType === 'effects' || optionsType === 'register') && !isEmpty(extraEffects)) {
    selectToDisplay = get(effects, [id], null)
  } else {
    selectToDisplay = options
  }


  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) {
      save({ key: props.id, value: checkedValue })
      dispatchEvent("onChange");
    } else {
      didMountRef.current = true;
    }
  }, [checkedValue])


  if (typeof selectToDisplay === 'string') {
    return <div>FEL</div>
  }

  const _helpBoxTemplate = helpBoxTemplateId === '_custom' ? helpBoxTemplate : get(htmlTemplates, [helpBoxTemplateId, 'html'], '')

  return <React.Fragment>
    <LabelWrapper>
      {extra.label && <GroupLabel>{label}</GroupLabel>}
      {
        !helpBoxAlwaysVisible && helpBoxIcon && <HelpIcon toggle={() => setHelpBoxOpen(!helpBoxOpen)} />
      }
    </LabelWrapper>
    {
      selectToDisplay && selectToDisplay.map((line, i) => {

        let { label, value } = line

        if (typeof line === 'string') {
          label = line;
          value = line;
        }

        return (<Radio
          key={i}
          name={name}
          label={label}
          value={value ? value : label}
          checkedValue={checkedValue}
          setCheckedValue={setCheckedValue}
          disabled={disabled}
          error={error}
        />)
      })
    }
    {
      (helpBoxAlwaysVisible || helpBoxIcon) && _helpBoxTemplate && helpBoxOpen && (
        <HelpBox template={_helpBoxTemplate} props={props} value={value} />
      )
    }
    <ValidationBar error={errorMessage} subLabel={subLabel} disableValidation={disableValidation} />

  </React.Fragment>

};

export default Radio3